import React from 'react';

import {Link} from './common/Link';
import {
  addUtmParamsToAppStoreUrl,
  addUtmParamsToPlayStoreUrl,
} from '../utils/url';
import {ButtonTracking} from '../types';

import {appStoreLink, playStoreLink} from '../constants';
import appStore from '../images/app-badge-1.png';
import playStore from '../images/play-badge-1.png';

export const DownloadButtons = ({
  utmParameters,
  appStoreUrl: appStoreUrlOverride,
  playStoreUrl: playStoreUrlOverride,
}: {
  utmParameters?: Record<string, string>;
  appStoreUrl?: string;
  playStoreUrl?: string;
}) => {
  const utmParamsWithDefaults = {
    utm_source: utmParameters?.utm_source || 'unknown',
    utm_medium: utmParameters?.utm_medium || 'unknown',
    utm_campaign: utmParameters?.utm_campaign || 'unknown',
  };

  const baseAppStoreUrl = appStoreUrlOverride ?? appStoreLink;
  const basePlayStoreUrl = playStoreUrlOverride ?? playStoreLink;

  const appStoreUrl = utmParameters
    ? addUtmParamsToAppStoreUrl(baseAppStoreUrl, utmParamsWithDefaults)
    : baseAppStoreUrl;

  const playStoreUrl = utmParameters
    ? addUtmParamsToPlayStoreUrl(basePlayStoreUrl, utmParamsWithDefaults)
    : basePlayStoreUrl;

  return (
    <div className="flex max-w-[300px] gap-4 pt-4 mx-auto">
      <Link
        href={appStoreUrl}
        external
        tracking={ButtonTracking.AppStoreDownload}>
        <img src={appStore} alt="the apple app store logo" />
      </Link>
      <Link
        href={playStoreUrl}
        external
        tracking={ButtonTracking.AppStoreDownload}>
        <img src={playStore} alt="the google play store logo" />
      </Link>
    </div>
  );
};
